// Tilt Hydrometer BLE Service and Characteristic UUIDs
export const BLE_SERVICE_UUID = "12345678-1234-5678-1234-56789abcdef0"

export const BLE_CHARACTERISTICS = {
  // Main reading: specific gravity, tilt angle, temperature
  SG_READING: "12345678-1234-5678-1234-56789abcdef8",
  // Accelerometer: x, y, z
  ACCELEROMETER: "12345678-1234-5678-1234-56789abcdef3",
  // PTH: temperature, pressure, humidity
  PTH: "12345678-1234-5678-1234-56789abcdef4",
  // Battery voltage
  BATTERY: "12345678-1234-5678-1234-56789abcdef5",
  // Calibration control
  CALIBRATION: "12345678-1234-5678-1234-56789abcdef6",
} as const

// Tilt device name prefix for filtering during scan
export const TILT_DEVICE_NAME_PREFIX = "Tilt"

// Check if Web Bluetooth API is available
export function isWebBluetoothSupported(): boolean {
  return typeof navigator !== "undefined" && "bluetooth" in navigator
}

// Get browser compatibility message
export function getBrowserCompatibilityMessage(): string | null {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return "Web Bluetooth is not available in this environment"
  }

  if (!("bluetooth" in navigator)) {
    const ua = (navigator as Navigator).userAgent.toLowerCase()
    if (ua.includes("firefox")) {
      return "Firefox does not support Web Bluetooth. Please use Chrome, Edge, or Opera."
    }
    if (ua.includes("safari") && !ua.includes("chrome")) {
      return "Safari does not support Web Bluetooth. Please use Chrome, Edge, or Opera."
    }
    return "Your browser does not support Web Bluetooth. Please use Chrome, Edge, or Opera."
  }

  return null
}
